import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

function MainLayout() {
  return (
    <div>
      <Navbar />
      {/* El <Outlet> renderizará el componente de la ruta actual (Dashboard, AdminPanel, etc.) */}
      <Outlet />
    </div>
  );
}

export default MainLayout;